import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ProjectCard } from '../components/ProjectCard';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
interface IProjectCategory {
  name: string;
  tag: string;
}
interface IProjects {
  title: string;
  description: string;
  category: string;
  thumbnailColor: string;
  link: string;
  likes: number;
}
const projectCategories: Array<IProjectCategory> = [{
  name: 'FinTech',
  tag: 'fintech'
}];
const projects: Array<IProjects> = [{
  title: 'Berry Finance',
  description: 'Automated business expense reconciliation platform for small-medium businesses.',
  category: 'FinTech',
  thumbnailColor: 'bg-purple-600',
  likes: 428,
  link: 'https://berry.stasisgroup.co'
}, {
  title: 'MAVIS Platform',
  description: 'A comprehensive utility management platform for municipalities to manage prepaid electricity, water, and other services.',
  category: 'GovTech',
  thumbnailColor: 'bg-blue-600',
  likes: 428,
  link: 'https://sondlane-mavis.stasisgroup.co'
}];
export function ProjectsPage() {
  let [projectsState, setProjectState] = useState<IProjects[]>(projects);
  let [activeTab, setActiveTab] = useState('');
  const handleSelectedActiveTab = (tabIndex: string) => {
    if (tabIndex === '') {
      setProjectState(projects);
      setActiveTab(tabIndex);
      return;
    }
    let filterProjectsState = projects.filter(project => project.category === tabIndex);
    setProjectState(filterProjectsState);
    setActiveTab(tabIndex);
  };
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white pt-24" data-id="element-217">
      <Navbar data-id="element-218" />

      {/* Header */}
      <section className="px-6 pb-12 md:pb-20 pt-10" data-id="element-219">
        <div className="max-w-3xl mx-auto text-center" data-id="element-220">
          <FadeIn data-id="element-221">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-222">
              Projects Launched
            </h1>
            <p className="text-xl text-neutral-500 leading-relaxed" data-id="element-223">
              We have helped 1 startup generate R200000+ in pre-launch sales.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Filter / Tabs */}
      <section className="px-6 mb-8" data-id="element-224">
        <div className="max-w-4xl mx-auto border-b border-neutral-100 flex gap-8 overflow-x-auto no-scrollbar" data-id="element-225">
          <button onClick={() => handleSelectedActiveTab('')} className={`pb-4 text-sm font-medium whitespace-nowrap ${activeTab === '' ? 'border-b-2 border-neutral-900 text-neutral-900' : 'text-neutral-500'}`} data-id="element-226">

            All Projects
          </button>

          {projectCategories.map((projectCategory, index) => <button key={index} onClick={() => handleSelectedActiveTab(projectCategory.name)} className={`pb-4 text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors whitespace-nowrap ${activeTab === projectCategory.name ? 'border-b-2 border-neutral-900 text-neutral-900' : ''}`} data-id="element-227">

              {projectCategory.name}
            </button>)}
        </div>
      </section>

      {/* Project List */}
      <section className="px-6 pb-32" data-id="element-228">
        <div className="max-w-4xl mx-auto" data-id="element-229">
          <div className="flex flex-col gap-2" data-id="element-230">
            {projectsState.map((project, index) => <ProjectCard key={index} index={index} {...project} data-id="element-231" />)}
          </div>

          <div className="mt-16 text-center" data-id="element-232">
            <FadeIn delay={0.4} data-id="element-233">
              <p className="text-neutral-500 mb-6" data-id="element-234">Have a project in mind?</p>
              <Button target="_blank" variant="primary" href="https://tally.so/r/PdO4XV" icon data-id="element-235">

                Start your project brief
              </Button>
            </FadeIn>
          </div>
        </div>
      </section>

      <Footer data-id="element-236" />
    </main>;
}